export enum HAITTOJENHALLINTATYYPPI {
  YLEINEN = 'YLEINEN',
  PYORALIIKENNE = 'PYORALIIKENNE',
  AUTOLIIKENNE = 'AUTOLIIKENNE',
  RAITIOLIIKENNE = 'RAITIOLIIKENNE',
  LINJAAUTOLIIKENNE = 'LINJAAUTOLIIKENNE',
  MUUT = 'MUUT',
}

export type HAITTOJENHALLINTATYYPPI_KEY = keyof typeof HAITTOJENHALLINTATYYPPI;

export type Haittojenhallintasuunnitelma = {
  [key in HAITTOJENHALLINTATYYPPI_KEY]?: string;
};
